{
	"altPixieset": "Pixieset",
	"ariaLogIn": "Log In",
	"ariaSignUp": "Sign Up",
	"logIn": "Log In",
	"logInTo": "Log in to {{productName}}",
	"noAccount": "Don't have an account?",
	"openBrowserToLogIn": "Open Browser to Log In",
	"signUp": "Sign Up"
}
